import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

type Route = { slug: string; title: string; short_description: string };

const TopRoutesSection = () => {
  const [routes, setRoutes] = useState<Route[]>([]);

  useEffect(() => {
    supabase
      .from("landing_pages")
      .select("slug,title,short_description")
      .eq("is_published", true)
      .order("sort_order")
      .limit(8)
      .then(({ data }) => setRoutes(data ?? []));
  }, []);

  if (routes.length === 0) return null;

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-10">
          <div>
            <p className="text-primary font-sans font-semibold tracking-[0.2em] uppercase text-xs mb-3">
              Most booked
            </p>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground">
              Top transfer routes
            </h2>
          </div>
          <Link
            to="/transfers"
            className="inline-flex items-center gap-2 font-sans font-semibold text-primary hover:underline"
          >
            View all routes <ArrowRight className="w-4 h-4" aria-hidden="true" />
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {routes.map((r) => (
            <Link
              key={r.slug}
              to={`/transfers/${r.slug}`}
              className="group rounded-xl border border-border bg-card p-5 hover:border-primary/50 hover:shadow-lg transition-all"
            >
              <MapPin className="w-5 h-5 text-primary mb-3" aria-hidden="true" />
              <h3 className="font-sans font-semibold text-card-foreground leading-snug mb-2 group-hover:text-primary transition-colors">
                {r.title}
              </h3>
              <p className="font-sans text-sm text-muted-foreground line-clamp-3">
                {r.short_description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TopRoutesSection;
